<template>
  <dp-loading v-if="loading" class="mt-5" />
  <div v-else id="app">
    <header>
      <dp-navbar
        v-if="order && order.id"
        :base-url="baseUrl"
        :logo-path="logoPath"
        :order-id="order.id"
        :basket-count="basketCount"
        :is-logged-in="isLoggedIn"
        :city="cityConfig"
      />
      <dp-navbar
        v-else
        :base-url="baseUrl"
        :logo-path="logoPath"
        :basket-count="basketCount"
        :is-logged-in="isLoggedIn"
        :city="cityConfig"
      />
    </header>

    <NotificationContainer />

    <main id="main" class="my-4">
      <router-view v-if="!navigationError" />
      <DpError v-if="navigationError" />
    </main>
    <dp-footer :base-url="baseUrl" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { DpNavbar, DpFooter, DpLoading, DpError } from '@docupet/component-library';
import NotificationContainer from '@/components/NotificationContainer';
import baseLocaleUrl from '@/mixins/baseLocaleUrl';
import { CookieMixins } from '@/mixins/cookie';

export default {
  components: {
    DpNavbar,
    DpFooter,
    DpLoading,
    NotificationContainer,
    DpError,
  },
  mixins: [baseLocaleUrl, CookieMixins],
  computed: {
    ...mapState({
      orderId: (state) => state.orderId,
      cityId: (state) => state.cityId,
      baseUrl: (state) => state.baseUrl,
      hasToken: (state) => !!state.token,
      city: (state) => (state.order.order ? state.order.order.city : null),
      cityConfig: (state) => state.user.city,
      user: (state) => state.user.user,
      order: (state) => state.order.order,
      loading: (state) =>
        state.navigation.isLoading || state.user.loading || state.petOwner.loading || state.order.loading || state.product.loading,
    }),
    ...mapGetters({
      pets: 'order/getPets',
      sections: 'order/getSections',
      navigationError: 'navigation/hasError',
    }),
    logoPath() {
      if (this.cityConfig && this.cityConfig.logo) {
        return this.cityConfig.logo.original;
      } else if (this.cityConfig && this.cityConfig.branding && this.cityConfig.branding.logoImage) {
        return this.cityConfig.branding.logoImage.original;
      } else {
        return '';
      }
    },
    basketCount() {
      return this.$route.name !== 'Confirmation' ? this.order?.itemsCount : 0;
    },
    isLoggedIn() {
      return Boolean(this.user?.id);
    },
  },
  watch: {
    order() {
      if (this.order && this.order.status != 'P' && this.$route.name != 'Confirmation') {
        const name = 'Confirmation';
        const orderId = this.orderId;
        this.$router.push({ name, params: { orderId } });
      }
      if (this.order && this.order.status == 'P' && this.$route.name == 'Confirmation') {
        const name = 'Basket';
        const orderId = this.orderId;
        this.$router.push({ name, params: { orderId } });
      }
    },
  },
  async created() {
    await this.$store.dispatch('user/fetchCity', { cityId: this.cityId });
    const data = await this.splitSetBasket();
    const discountCode = this.getBasketCodeCookie();
    if (this.hasToken) {
      if ((data?.length || 0) > 0) {
        window.location.href = this.baseLocaleUrl() + '/store';
      } else {
        await this.$store.dispatch('user/fetchUser');
        await this.$store.dispatch('petOwner/fetchPetOwner');
        await this.$store.dispatch('order/fetchOrder', this.orderId).then(() => {
          if (discountCode) {
            this.$store
              .dispatch('order/applyDiscount', { orderId: this.orderId, code: discountCode })
              .then(() => this.removeBasketCodeCookie());
          }
        });
      }
    } else if ((data?.length || 0) > 0) {
      await this.$store.dispatch('order/createLocalOrder', {
        vm: this,
        cityId: this.cityId,
        data,
        discountCode,
        changingDiscount: false,
      });
    }
    await this.$store.dispatch('product/fetchConnectorProducts', { cityId: this.cityId }, { root: true });
    await this.$store.dispatch('product/fetchGlowTagProduct', null, { root: true });
  },
};
</script>

<style lang="scss">
@import '@docupet/component-library/src/assets/styles/main';
@import '@/assets/styles/main';
</style>
